export default __webpack_public_path__ + "static/media/samsung_stimuli_fr_phone.f180204e.mp4";